import { IDSRDeleteResponse } from './dsr.interface';

import React from 'react';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import OverlayDialog from '../../../app/common/components/OverlayDialog';
import Icon from '../../../app/common/components/Icon';
import ICONS from '../../../app/common/constants/icons';

import {
    DsrStatusContainer,
    DeleteServicesInfo,
    DeleteServicesInfoText,
    DsrStatusInfoText,
    DsrStatusInfoLink,
    DsrModalActions,
} from './DsrLinkStyles';
import Button from '../../../app/common/components/Button';

export type DsrDeleteRequestStatusProps = {
    dsrStatus: IDSRDeleteResponse;
    showDsrStatusMessage: boolean;
    toggleDsrStatusMessage(value: boolean): void;
};

export const DsrDeleteRequestStatus: React.FC<DsrDeleteRequestStatusProps> = (props) => {
    const {
        dsrStatus: { success },
        showDsrStatusMessage,
        toggleDsrStatusMessage,
    } = props;

    if (success) {
        const requestDate = new Date().toLocaleDateString();
        return (
            <div data-qa-id="dsr-delete-service-status">
                <DsrStatusContainer>
                    <DsrStatusInfoLink
                        onClick={() => toggleDsrStatusMessage(true)}
                        data-qa-id="dsr-delete-status-info-link"
                    >
                        <Icon icon={ICONS.QUESTION} size={'20px'} viewBoxMax="32" />
                    </DsrStatusInfoLink>
                    <DeleteServicesInfo data-qa-id="dsr-delete-service-link-requested">
                        <DeleteServicesInfoText>
                            {TranslationHelpers.getFormattedMessage('dsr.account_deletion')}
                        </DeleteServicesInfoText>
                        <DeleteServicesInfoText>
                            {TranslationHelpers.getFormattedMessage(
                                'dsr.account_deletion_requested',
                            )}
                            &nbsp;{requestDate.split('T')[0]}
                        </DeleteServicesInfoText>
                    </DeleteServicesInfo>
                </DsrStatusContainer>
                <OverlayDialog
                    title={TranslationHelpers.getMessageDescriptor('dsr.account_deletion')}
                    isOpen={showDsrStatusMessage}
                    onClose={() => toggleDsrStatusMessage(false)}
                >
                    <DsrStatusInfoText data-qa-id="dsr-status-info-text">
                        {TranslationHelpers.getFormattedMessage(
                            'dsr.delete_service_confirmation_body_1',
                        )}
                        <br />
                        <br />
                        {TranslationHelpers.getFormattedMessage(
                            'dsr.delete_service_confirmation_body_2',
                        )}
                        <br />
                        <br />
                        {TranslationHelpers.getFormattedMessage(
                            'dsr.delete_service_confirmation_body_3',
                        )}
                    </DsrStatusInfoText>
                    <DsrModalActions>
                        <Button
                            qaId="delete-confirmation-cancel"
                            id="cancel"
                            primary
                            type="button"
                            text={TranslationHelpers.getMessageDescriptor('button.close')}
                            onClick={() => toggleDsrStatusMessage(false)}
                            disabled={false}
                            success={false}
                        />
                    </DsrModalActions>
                </OverlayDialog>
            </div>
        );
    }
    return null;
};
